(function () {
  var MESSAGE_ID = 'product-variant-message';
  var DEFAULT_MESSAGE = 'Vælg venligst variant';

  function getProductData() {
    if (window.product && window.product.variants) return window.product;
    var el = document.getElementById('product-json');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getForm() {
    var btn = document.getElementById('btn_submite_btn');
    if (btn) {
      var form = btn.closest('form');
      if (form) return form;
    }
    return document.querySelector('.description_product form[action*="/cart/add"], form[action*="/cart/add"]');
  }

  function getVariantMessageText(form) {
    var existing = document.getElementById(MESSAGE_ID);
    if (existing && existing.textContent) {
      return existing.textContent.trim();
    }
    return (form && form.getAttribute('data-variant-message')) || DEFAULT_MESSAGE;
  }

  function getVariantSelect(form) {
    if (!form) return null;
    var productSelect = form.querySelector('#productSelect');
    if (productSelect && productSelect.tagName === 'SELECT') return productSelect;
    var variantSelect = form.querySelector('#variant_select');
    if (variantSelect && variantSelect.tagName === 'SELECT') return variantSelect;
    return form.querySelector('select[name="id"]');
  }

  function getSizeOptions() {
    return document.querySelectorAll('.options_size li:not(.disable)');
  }

  function getBundleOptions() {
    return document.querySelectorAll(
      '.bundels_products .body_dundels ul > li[data-discount], .bundels_products .body_dundels ul > li[data-picker-type="subscription"], .bundels_products .body_dundels ul > li[data-picker-type="quantity"], .bundels_products .body_dundels ul > li[index]'
    );
  }

  function needsSizePick() {
    return getSizeOptions().length > 0;
  }

  function needsBundlePick() {
    return getBundleOptions().length > 0;
  }

  function needsVarcangerPick() {
    return document.querySelectorAll('.varcanger').length > 0;
  }

  function hasOnlyOneVariant() {
    var productData = getProductData();
    return !!(productData && productData.variants && productData.variants.length === 1);
  }

  function requiresVariantPick() {
    return needsSizePick() || needsBundlePick() || needsVarcangerPick();
  }

  function removeDuplicateVariantInput(form) {
    if (!form) return;
    var select = getVariantSelect(form);
    var hidden = form.querySelector('#variant-id-input');
    if (select && hidden) hidden.remove();
  }

  function ensureMessage(form) {
    var existing = document.getElementById(MESSAGE_ID);
    if (existing) return existing;

    var text = getVariantMessageText(form);
    var btn = document.getElementById('btn_submite_btn');
    if (!btn) return null;

    var msg = document.createElement('p');
    msg.id = MESSAGE_ID;
    msg.className = 'product-variant-message';
    msg.setAttribute('role', 'alert');
    msg.hidden = true;
    msg.textContent = text;
    btn.parentNode.insertBefore(msg, btn);
    return msg;
  }

  function showMessage() {
    var msg = ensureMessage(getForm());
    if (!msg) return;
    msg.hidden = false;
    msg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function hideMessage() {
    var msg = document.getElementById(MESSAGE_ID);
    if (msg) msg.hidden = true;
  }

  function clearPickerActiveState() {
    getSizeOptions().forEach(function (li) {
      li.classList.remove('active');
    });
    getBundleOptions().forEach(function (li) {
      li.classList.remove('active');
    });
  }

  function resetVariantSelect(form) {
    var select = getVariantSelect(form);
    if (!select) return;

    if (!select.querySelector('option[value=""]')) {
      var opt = document.createElement('option');
      opt.value = '';
      opt.textContent = 'Vælg variant';
      opt.disabled = true;
      opt.hidden = true;
      opt.selected = true;
      select.insertBefore(opt, select.firstChild);
    }

    select.value = '';
    select.disabled = true;
    if (form) form.dataset.variantSelected = 'false';
  }

  function getActiveSizeLi() {
    return document.querySelector('.options_size li.active:not(.disable)');
  }

  function getActiveBundleLi() {
    var active = null;
    getBundleOptions().forEach(function (li) {
      if (li.classList.contains('active')) active = li;
    });
    return active;
  }

  function syncRechargePlan(bundleLi) {
    if (!bundleLi) return;
    var indexAttr = bundleLi.getAttribute('index');
    if (indexAttr === null || indexAttr === undefined) return;

    var planIndex = parseInt(String(indexAttr).trim(), 10);
    if (isNaN(planIndex)) return;

    var sellingPlansSelect = document.querySelector('.rc_widget__option__plans__dropdown');
    if (sellingPlansSelect && sellingPlansSelect.options.length > planIndex) {
      sellingPlansSelect.selectedIndex = planIndex;
      sellingPlansSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function resolveVariantFromPickers() {
    var productData = getProductData();
    if (!productData) return null;

    var activeSizeLi = getActiveSizeLi();
    if (!activeSizeLi) {
      if (hasOnlyOneVariant()) return productData.variants[0];
      return null;
    }

    var variantIdAttr = (activeSizeLi.getAttribute('data-variantid') || '').trim();
    if (variantIdAttr) {
      return (
        productData.variants.find(function (v) {
          return String(v.id) === String(variantIdAttr);
        }) || null
      );
    }

    var size = (activeSizeLi.getAttribute('data-size') || '').trim();
    var activeBundleLi = getActiveBundleLi();
    var discount = activeBundleLi ? (activeBundleLi.getAttribute('data-discount') || '').trim() : '';

    if (needsBundlePick() && !activeBundleLi) return null;

    if (discount) {
      var combined = (size + ' / ' + discount).trim();
      return (
        productData.variants.find(function (v) {
          return v.title === combined || v.title.trim() === combined;
        }) || null
      );
    }

    return (
      productData.variants.find(function (v) {
        return (
          v.title === size ||
          v.title.indexOf(size + ' /') === 0 ||
          String(v.option1 || '').trim() === size
        );
      }) || null
    );
  }

  function applyVariantToForm(form, variant) {
    if (!form || !variant) return false;

    var select = getVariantSelect(form);
    if (select) {
      select.disabled = false;
      select.value = String(variant.id);
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    var hiddenInput = form.querySelector('#variant-id-input, input[name="id"]');
    if (hiddenInput && hiddenInput.tagName === 'INPUT') {
      hiddenInput.value = String(variant.id);
      return true;
    }

    return false;
  }

  function hasUserPickedAllRequired(form) {
    if (!form) return false;
    if (needsSizePick() && form.dataset.userPickedSize !== 'true') return false;
    if (needsBundlePick() && form.dataset.userPickedBundle !== 'true') return false;
    if (needsVarcangerPick()) {
      var selectors = document.querySelectorAll('.varcanger');
      for (var i = 0; i < selectors.length; i++) {
        if (!selectors[i].value) return false;
      }
    }
    return true;
  }

  function isPickComplete(form) {
    if (!requiresVariantPick()) return true;
    if (!form) return false;

    if (!hasUserPickedAllRequired(form)) return false;

    var variant = resolveVariantFromPickers();
    if (!variant) return false;

    applyVariantToForm(form, variant);
    form.dataset.variantSelected = 'true';
    return true;
  }

  function syncPickersFromUrlVariant(form) {
    var variantId = new URLSearchParams(window.location.search).get('variant');
    if (!variantId) return false;

    var productData = getProductData();
    if (!productData) return false;

    var matchingVariant = productData.variants.find(function (v) {
      return String(v.id) === String(variantId);
    });
    if (!matchingVariant) return false;

    var titleParts = matchingVariant.title.split(' / ');
    var sizeValue = titleParts[0] ? titleParts[0].trim() : '';
    var discountValue = titleParts.slice(1).join(' / ').trim();

    getSizeOptions().forEach(function (li) {
      var size = li.getAttribute('data-size');
      li.classList.toggle('active', size && size.trim() === sizeValue);
    });

    getBundleOptions().forEach(function (li) {
      var discount = li.getAttribute('data-discount');
      if (discount) {
        li.classList.toggle('active', discount.trim() === discountValue);
      }
    });

    applyVariantToForm(form, matchingVariant);
    form.dataset.userPickedSize = 'true';
    form.dataset.userPickedBundle = needsBundlePick() ? 'true' : 'false';
    if (!needsBundlePick()) form.dataset.userPickedBundle = 'true';
    return true;
  }

  function bindSubscriptionPickerClicks(form) {
    if (document._subscriptionPickerBound) return;
    document._subscriptionPickerBound = true;

    document.addEventListener('click', function (e) {
      var li = e.target.closest('.bundels_products .body_dundels ul > li[data-picker-type="subscription"]');
      if (!li) return;

      var list = li.closest('ul');
      if (!list) return;

      list.querySelectorAll('li[data-picker-type="subscription"]').forEach(function (el) {
        el.classList.remove('active');
      });
      li.classList.add('active');

      syncRechargePlan(li);

      var targetForm = form || getForm();
      if (targetForm) {
        targetForm.dataset.userPickedBundle = 'true';
        if (isPickComplete(targetForm)) hideMessage();
      }
    });
  }

  function bindPickerClicks(form) {
    getSizeOptions().forEach(function (li) {
      li.addEventListener('click', function (e) {
        if (li.classList.contains('disable')) return;

        getSizeOptions().forEach(function (el) {
          el.classList.remove('active');
        });
        li.classList.add('active');
        form.dataset.userPickedSize = 'true';

        if (isPickComplete(form)) {
          hideMessage();
        } else {
          form.dataset.variantSelected = 'false';
          if (needsBundlePick()) {
            resetVariantSelect(form);
          }
        }
      });
    });

    getBundleOptions().forEach(function (li) {
      if (li.getAttribute('data-picker-type') === 'subscription') return;

      li.addEventListener('click', function () {
        getBundleOptions().forEach(function (el) {
          el.classList.remove('active');
        });
        li.classList.add('active');
        form.dataset.userPickedBundle = 'true';

        syncRechargePlan(li);

        if (typeof window.varcanger === 'function') {
          window.varcanger();
        }

        if (isPickComplete(form)) {
          hideMessage();
        } else {
          form.dataset.variantSelected = 'false';
        }
      });
    });

    document.querySelectorAll('.varcanger').forEach(function (sel) {
      sel.addEventListener('change', function () {
        if (typeof window.varcanger === 'function') {
          window.varcanger();
        }
        form.dataset.userPickedSize = 'true';
        form.dataset.userPickedBundle = 'true';
        if (isPickComplete(form)) hideMessage();
      });
    });
  }

  function blockAddToCart(form) {
    var btn = document.getElementById('btn_submite_btn');
    if (!btn) return;

    function handleAttempt(event) {
      if (!requiresVariantPick()) return true;

      if (!isPickComplete(form)) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
        form.dataset.variantSelected = 'false';
        showMessage();
        return false;
      }

      hideMessage();
      return true;
    }

    btn.addEventListener('click', handleAttempt, true);

    form.addEventListener(
      'submit',
      function (e) {
        if (!handleAttempt(e)) return;
      },
      true
    );

      var mobileBtn = document.getElementById('btn_submite_btn2');
      if (mobileBtn) {
        mobileBtn.addEventListener(
          'click',
          function (e) {
            if (!handleAttempt(e)) {
              e.preventDefault();
              return false;
            }
          },
          true
        );
      }

      var mobileBtn3 = document.getElementById('btn_submite_btn3');
      if (mobileBtn3) {
        mobileBtn3.addEventListener(
          'click',
          function (e) {
            if (!handleAttempt(e)) {
              e.preventDefault();
              return false;
            }
          },
          true
        );
      }
  }

  function init() {
    var form = getForm();
    bindSubscriptionPickerClicks(form);

    if (!form) return;

    if (needsBundlePick() && !needsSizePick() && hasOnlyOneVariant()) {
      ensureMessage(form);
      form.dataset.userPickedSize = 'true';
      form.dataset.userPickedBundle = 'false';
      form.dataset.variantSelected = 'true';
      blockAddToCart(form);
      return;
    }

    if (!requiresVariantPick()) return;

    removeDuplicateVariantInput(form);
    ensureMessage(form);

    form.dataset.userPickedSize = needsSizePick() ? 'false' : 'true';
    form.dataset.userPickedBundle = needsBundlePick() ? 'false' : 'true';
    form.dataset.variantSelected = 'false';

    if (!syncPickersFromUrlVariant(form)) {
      clearPickerActiveState();
      if (getVariantSelect(form)) resetVariantSelect(form);
    }

    bindPickerClicks(form);
    blockAddToCart(form);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function () {
    var form = getForm();
    if (!form) return;

    if (needsBundlePick() && !needsSizePick() && hasOnlyOneVariant()) return;

    if (!requiresVariantPick()) return;
    if (new URLSearchParams(window.location.search).get('variant')) return;

    clearPickerActiveState();
    if (getVariantSelect(form)) resetVariantSelect(form);
    form.dataset.userPickedSize = needsSizePick() ? 'false' : 'true';
    form.dataset.userPickedBundle = needsBundlePick() ? 'false' : 'true';
  });
})();
